import React from 'react';
import { useTranslation } from 'react-i18next';
import VotingResult from '../../common/VotingResult';
import Card from '../../common/Card/Card';
import ChevronLink from '../../common/ChevronLink/ChevronLink';
import './VotingDataCard.css';
import IconText from '../../common/IconText/IconText';
import { VotingCardDataType } from '../../../types';
import { useSearchParams } from 'react-router-dom';
import { URLKeys } from '../../../Constants';

type Props = {
    data: VotingCardDataType;
};

export const VotingDataCard = ({
    data: { voteId, voteNumber, meetingNumber, voteDescription, voteResult, secret, valid, procedural }
}: Props) => {
    const { t } = useTranslation();
    const searchParams = useSearchParams();
    const showFullText = searchParams[0].get(URLKeys.voteDescriptionText) === URLKeys.fullText;

    return (
        <>
            <Card className='voting-card'>
                <div className='data-card-header'>
                    <div>
                        <h6>{meetingNumber}</h6>
                        <h6>{`${t('no.')} ${voteNumber}`}</h6>
                        <VotingResult voteResult={voteResult} />
                    </div>
                    {(secret || !valid || procedural) && (
                        <div className='special-voting-type'>
                            {!valid && <IconText icon='unpublished' text={t('invalid-option')} className='primary' />}
                            {secret && <IconText icon='lock' text={t('secret-option')} className='primary' />}
                            {procedural && (
                                <IconText icon='settings' text={t('procedural-option')} className='primary' />
                            )}
                        </div>
                    )}
                </div>
                <div className={`data-card-body${showFullText ? '' : ' clipped-text'}`}>
                    <p>{voteDescription}</p>
                    <ChevronLink
                        chevronDirection='right'
                        text={t('voting-detail')}
                        linkUrl={`${voteId}`}
                        linkDisabled
                    />
                </div>
            </Card>
        </>
    );
};
